import { fromJS } from 'immutable';
import { LoaderStatus } from '../common/components/CommonLoader';

const initialData = fromJS({
  snapshotStatistics: null,
  customerStatistics: null,
  saleStatistics: null,
  feesStatistics: null,
  purchaseStatistics: null,
});

export const FETCH_AGGREGATED_STATISTICS_SUCCESS = 'FETCH_AGGREGATED_STATISTICS_SUCCESS';
export const FETCH_SNAPSHOT_STATISTICS_SUCCESS = 'FETCH_SNAPSHOT_STATISTICS_SUCCESS';
export const FETCH_CUSTOMER_STATISTICS_SUCCESS = 'FETCH_CUSTOMER_STATISTICS_SUCCESS';
export const FETCH_SALE_STATISTICS_SUCCESS = 'FETCH_SALE_STATISTICS_SUCCESS';
export const FETCH_FEES_STATISTICS_SUCCESS = 'FETCH_FEES_STATISTICS_SUCCESS';
export const FETCH_PURCHASE_STATISTICS_SUCCESS = 'FETCH_PURCHASE_STATISTICS_SUCCESS';

export default (state = initialData, { type, payload }) => {
  switch (type) {
    case FETCH_AGGREGATED_STATISTICS_SUCCESS: {
      return state.merge({
        snapshotStatistics: payload.snapshotStatistics,
        customerStatistics: payload.customerStatistics,
        feesStatistics: payload.feesStatistics,
        saleStatistics: payload.saleStatistics,
        purchaseStatistics: payload.purchaseStatistics,
        loaderStatus: LoaderStatus.SUCCESS,
      });
    }
    case FETCH_SNAPSHOT_STATISTICS_SUCCESS: {
      return state.merge({
        snapshotStatistics: payload.snapshotStatistics,
      });
    }
    case FETCH_CUSTOMER_STATISTICS_SUCCESS: {
      return state.merge({
        customerStatistics: payload.customerStatistics,
      });
    }
    case FETCH_SALE_STATISTICS_SUCCESS: {
      return state.merge({
        saleStatistics: payload.saleStatistics,
      });
    }
    case FETCH_FEES_STATISTICS_SUCCESS: {
      return state.merge({
        feesStatistics: payload.feesStatistics,
      });
    }
    case FETCH_PURCHASE_STATISTICS_SUCCESS: {
      return state.merge({
        purchaseStatistics: payload.purchaseStatistics,
      });
    }
    default:
      return state;
  }
};
